module.exports = __webpack_public_path__ + "img/f3a7394.jpg";